// import: styles
// import: assets
// import: constants
import { Box } from '@mui/material';
import * as loadingAnimationData from 'core/assets/lottie/green-loader-animation.json';
import BaseTypography from 'core/components/typography/BaseTypography';
import { toastConfig } from 'core/config/ToastConfig';
import { DownloadStatus } from 'core/constants/enums/DownloadStatus.ts';
import { ToastType } from 'core/constants/enums/ToastTypeEnum.ts';
import LottieAnimation from 'core/layouts/components/lottie-animation/LottieAnimation';
import { toastStyles } from 'core/layouts/components/toast/ToastStyles';
import appTheme from 'core/layouts/ui-blocks/AppTheme';
import { colorPalette } from 'core/layouts/ui-blocks/ColorPalette';
import React from 'react';
import { Bounce, toast } from 'react-toastify';

// import: utils
// import: services
// import: redux
// import: components
// import: lazy load components

export function Msg(props) {
	const { msgConfig = { icon: null, title: '', subtitle: '' }, status } = props;

	return (
		<Box id="msg" sx={toastStyles.msg}>
			<Box id="icon" sx={toastStyles.icon}>
				{status === DownloadStatus.PENDING ? (
					<Box sx={toastStyles.loadingAssetIndicator}>
						<LottieAnimation animationData={loadingAnimationData} loop />
					</Box>
				) : (
					msgConfig?.icon
				)}
			</Box>
			<Box id="msg" sx={toastStyles.flexCol}>
				<BaseTypography
					variant="b2_caption"
					styles={[appTheme.typography.t2_medium, { color: colorPalette.dark5 }]}
				>
					{msgConfig?.title}
				</BaseTypography>
				{msgConfig?.subtitle && (
					<BaseTypography
						variant="b1_medium"
						styles={[appTheme.typography.b2_caption, { color: colorPalette.grey600 }]}
					>
						{msgConfig?.subtitle}
					</BaseTypography>
				)}
			</Box>
		</Box>
	);
}

export const sendPromiseToast = async (promise) => {
	await toast.promise(
		promise,
		{
			pending: {
				render() {
					return (
						<Msg
							msgConfig={toastConfig[ToastType.DOWNLOAD_PENDING]}
							status={DownloadStatus.PENDING}
						/>
					);
				},
			},
			success: {
				render() {
					return (
						<Msg
							msgConfig={toastConfig[ToastType.DOWNLOAD_SUCCESS]}
							status={DownloadStatus.SUCCESS}
						/>
					);
				},
			},
			error: {
				render() {
					return (
						<Msg msgConfig={toastConfig[ToastType.DOWNLOAD_ERROR]} status={DownloadStatus.ERROR} />
					);
				},
			},
		},
		{
			position: 'bottom-right',
			autoClose: 1000,
			hideProgressBar: true,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: false,
			progress: undefined,
			theme: 'dark',
			transition: Bounce,
		},
	);
};
